import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class PlantIdRequest {    
    @ApiProperty()
    @IsNotEmpty()
    plantId: number;
}